import React, { Fragment } from 'react'

import Stars from 'components/Stars'
import {
  SeeAll,
  Keywords,
  Categories,
  Suggestions,
  Autocomplete,
  CategoryItem,
  KeywordsItem,
  SuggestionsItem,
  AutocompleteHeading,
} from '../components/SearchBox.style'
import categoryUrl from 'helpers/categoryUrl'
import SearchService from 'services/SearchService'
import { BrowserView } from 'components/DeviceDetect'

const SearchAutoComplete = props => {
  const { result, keyword, onKeywordChoose, onClick, onSeeAll } = props

  const searchProductChosen = product_id => {
    if (result.search_id) {
      SearchService.searchProductChosen(result.search_id, product_id)
    }
  }

  return (
    <Fragment>
      <Autocomplete>
        {result.products?.length > 0 && (
          <Suggestions>
            <AutocompleteHeading>ძებნის შედეგი</AutocompleteHeading>
            {result.products.map(product => (
              <SuggestionsItem
                key={product.id}
                onClick={() => {
                  onClick()
                  searchProductChosen(product.id)
                }}
                to={`/product/${product.slug || ''}`}
              >
                <img
                  className="search-product-image"
                  src={product.image}
                  alt={product.name}
                />
                <div className="item-info">
                  <h2>{product.name}</h2>
                  {product.price ? <p>{product.price}₾</p> : 'არ არის მარაგში '}
                  <BrowserView>
                    <Stars amount={Math.round(product.rating / 2)} />
                  </BrowserView>
                </div>
              </SuggestionsItem>
            ))}
          </Suggestions>
        )}
        {result.suggestions?.length > 0 && (
          <Keywords>
            <AutocompleteHeading>საძიებო სიტყვა</AutocompleteHeading>
            {(result.suggestions || []).map(s => (
              <KeywordsItem
                to={`/search/${s.text}`}
                key={s.id}
                onClick={() => {
                  onKeywordChoose(s.text)
                  onClick()
                }}
              >
                {s.text}
              </KeywordsItem>
            ))}
          </Keywords>
        )}
        {result.categories?.length > 0 && (
          <Categories>
            <AutocompleteHeading>კატეგორიები</AutocompleteHeading>
            {(result.categories || []).map(s => (
              <CategoryItem
                key={s.id}
                to={categoryUrl(s.slug, s.count === '0' ? null : keyword)}
              >
                {s.title}
                {s.count ? `(${s.count})` : null}
              </CategoryItem>
            ))}
          </Categories>
        )}
        {result.notfound && (
          <Categories>
            <AutocompleteHeading>არაფერი მოიძებნა</AutocompleteHeading>
          </Categories>
        )}
        {!result.notfound && <SeeAll onClick={onSeeAll}>ყველას ნახვა</SeeAll>}
      </Autocomplete>
    </Fragment>
  )
}

export default SearchAutoComplete
